<template>
  <div class="order-detail-card">
    <div class="card-header">
      <div class="order-no">
        <span>{{$t('components_order_order_detail_card_677')}}</span>
        <span>{{ orderInfo.orderNo }}</span>
        <span @click="copyOrderNo(orderInfo.orderNo)">
          <img src="~@/assets/image/fps-icon/copy-icon.png" alt="" />
        </span>
      </div>
      <div :class="['order-status', orderStatusClass]">
        {{
          orderInfo.status
            | orderStatusTranslateUpperCase(type, orderInfo.refundType)
        }}
      </div>
    </div>
    <div class="card-body">
      <div class="skill-info">
        <div class="skill-image" @click.stop="jumpMasterDetail">
          <img :src="targetData.avatarUrl + '?d=300x300'" alt="" />
        </div>
        <div class="skill-text">
          <p class="user-name">
            {{ targetData.nickname }}
          </p>
          <p class="skill-name">
            {{ orderInfo.orderItemVoList[0].playerSkillName }}
            <span v-if="['HalfHour','Minutes7'].includes(orderInfo.orderItemVoList[0].salesUnit)">({{orderInfo.orderItemVoList[0].salesUnit | salesUnitTranslate}}*{{orderInfo.orderItemVoList[0].count}})</span>
            <span v-else>({{orderInfo.orderItemVoList[0].count}}{{orderInfo.orderItemVoList[0].salesUnit | salesUnitTranslate}})</span>
            <span class="give-away-info" v-if="orderInfo.giveAwayInfo">{{$t('components_order_order_card_500', [ orderInfo.giveAwayInfo.giftNum ])}}</span
            >
          </p>
          <p class="subtotal-price">
            <span>{{$t('upgrade_page_views_order_components_pay_info_341')}}</span>
            <span
              >{{ '$' || orderInfo.currencyKind
              }}{{ orderInfo.originalAmount }}</span
            >
          </p>
          <p class="order-count">
            <span>{{$t('components_order_order_detail_card_678')}}</span>
            <span>{{ orderInfo.orderItemVoList[0].count }}</span>
          </p>
          <p v-if="orderInfo.discountedAmount > 0" class="discount-price">
            <span>{{$t('components_order_order_detail_card_679')}}</span>
            <span
              >-{{ '$' || orderInfo.currencyKind
              }}{{ orderInfo.discountedAmount }}</span
            >
          </p>
          <p class="skill-total">
            <span>{{$t('upgrade_page_views_order_components_pay_info_346')}}</span>
            <span
              >{{ '$' || orderInfo.currencyKind
              }}{{ orderInfo.currentAmount }}</span
            >
          </p>
          <div class="operation-container">
            <div
              class="operation-btn"
              @click.stop="$emit('cancleOrder', orderInfo.orderNo)"
              v-show="type === 'c' && orderInfo.status === 'Effective'"
            >{{$t('components_order_order_card_504')}}</div>
            <div
              class="operation-btn"
              @click.stop="$emit('controversyOrder', orderInfo.orderNo)"
              v-show="
                type === 'c' &&
                (orderInfo.status === 'Processing' ||
                  orderInfo.status === 'PlayerConfirm')
              "
            >{{$t('components_order_order_card_556')}}</div>
            <div
              class="operation-btn"
              @click.stop="$emit('writeReview', orderInfo)"
              v-show="type === 'c' && orderInfo.status === 'Completed'"
            >{{$t('components_order_order_card_509')}}</div>
            <div
              class="operation-btn"
              @click.stop="$emit('refoundDetail', orderInfo.orderNo)"
              v-show="refoundDetailShowBtn"
            >{{$t('components_order_order_card_506')}}</div>
            <div
              class="operation-btn"
              @click.stop="$emit('refoundOrder', orderInfo.orderNo)"
              v-show="orderInfo.status === 'Processing' && type === 'b'"
            >{{$t('components_order_order_card_505')}}</div>
            <div
              class="operation-btn red-button"
              @click.stop="$emit('completeOrder', orderInfo.orderNo)"
              v-show="showConfirmButton"
            >{{$t('components_order_order_card_503')}}</div>
            <div
              class="operation-btn red-button"
              @click.stop="$emit('acceptOrder', orderInfo.orderNo)"
              v-show="orderInfo.status === 'Effective' && type === 'b'"
            >{{$t('components_order_order_card_511')}}</div>
          </div>
        </div>
      </div>
      <div
        v-if="
          orderInfo.paymentStatus === 'Refunding' ||
          orderInfo.paymentStatus === 'Refunded'
        "
        class="skill-refund"
      >
        <span
          :class="orderInfo.paymentStatus === 'Refunding' ? 'highlight' : ''"
          >{{ orderInfo.paymentStatus }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'

export default {
  props: {
    type: String,
    orderInfo: {
      type: Object,
      default() {
        return {
          orderItemVoList: [{}],
        };
      },
    },
  },
  created() {},
  computed: {
    targetData() {
      let result = {};
      const {
        playerUserAvatar,
        userAvatarUrl,
        userNickname,
        playerUserNickname,
        userUuid,
        playerUserUuid,
      } = this.orderInfo;

      if (this.type === 'b') {
        result = {
          avatarUrl: userAvatarUrl,
          nickname: userNickname,
          uuid: userUuid,
        };
      } else if (this.type === 'c') {
        result = {
          avatarUrl: playerUserAvatar,
          nickname: playerUserNickname,
          uuid: playerUserUuid,
        };
      }

      return result;
    },
    salesUnit() {
      const salesUnit = this.orderInfo.orderItemVoList[0].salesUnit;

      return {
        h: 'hour',
        g: 'game',
      }[salesUnit];
    },
    orderStatusClass() {
      const { status } = this.orderInfo;
      const highlightStatusMaps = [
        'Processing',
        'completed',
        'Finished',
        'Invalid',
      ];

      if (highlightStatusMaps.includes(status)) return 'normal';

      return '';
    },
    showConfirmButton() {
      let isCshow =
        this.type === 'c' && this.orderInfo.status === 'PlayerConfirm';
      return (
        this.orderInfo.status === 'Processing' ||
        isCshow
      );
    },
    refoundDetailShowBtn() {
      let map = ['REFUND_SUCCESS', 'Controversy', 'Negotiate'];
       let tui_success=(this.orderInfo.status === 'Invalid'&&this.orderInfo.refundType === 'FULL')
      return (map.indexOf(this.orderInfo.status) !== -1)||tui_success;
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * @description 打开IM
     */
    openChatView() {},
    /**
     * @description 打开大神详情页
     */
    jumpMasterDetail() {
      if (this.orderInfo.userKind === 'Player') {
        this.$router.push({
          name: 'playerDetail',
          params: {
            uuid:
              this.type === 'c'
                ? this.orderInfo.playerUserUuid
                : this.orderInfo.userUuid,
            skill: this.orderInfo.orderItemVoList[0].playerSkillId,
          },
        });
      }
    },
    copyOrderNo(orderNo) {
      let input = document.createElement('input');
      input.value = orderNo;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length),
        document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message({
        type: 'success',
        message: i18n.t('components_order_order_detail_card_680'),
      });
    },
  },
};
</script>
<style lang="scss">
.order-detail-card {
  .skill-image {
    background: #f0f0f0;
    display: flex;
    border-radius: 4px;
    align-items: center;
    img {
      width: 100px;
      cursor: pointer;
      height: auto !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  margin-bottom: 12px;
  .order-no {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #333;
    text-align: left;
    white-space: nowrap;
    color: #999;

    img {
      width: 16px;
      height: 16px;
      margin-left: 4px;
    }
  }

  .order-status {
    color: #ff8973;
  }

  .normal {
    color: #999999;
  }
}

.card-body {
  // margin: 0 36px;
  // min-height: 478px;
  // border-radius: 16px;
  // padding-bottom: 30px;
  background: #ffffff;
  border-bottom: 1px solid #e3e3e3;
  // box-shadow: 4px 8px 48px 0 rgba(17,17,53,0.08);

  .user-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 150px;
    padding: 0 26px;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .img {
      position: relative;
      width: 80px;
      height: 80px;
    }

    .master-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 32px;
      height: 32px;
      z-index: 2;
    }

    .right img {
      width: 48px;
      height: 48px;
    }

    span {
      font-weight: bold;
      font-size: 32px;
      text-shadow: 4px 8px 48px rgba(17, 17, 53, 0.08);
      margin-left: 30px;
    }
  }

  .skill-info {
    display: flex;
    align-items: flex-start;
    .skill-image {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
      border-radius: 8px;
      margin-right: 32px;
      overflow: hidden;
      cursor: pointer;
    }
    .skill-text {
      flex-grow: 0;
      min-height: 149px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        font-size: 14px;
        line-height: 20px;
        color: #999999;
        margin-bottom: 4px;
        &.user-name {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          line-height: 20px;
          cursor: pointer;
          margin-bottom: 5px;
        }

        &.skill-name {
          justify-content: flex-start;
          font-size: 14px;
          color: #333;
          font-weight: normal;
          line-height: 20px;
          margin-bottom: 5px;
        }
        .give-away-info {
          margin-left: 6px;
          color: $color-yellow;
        }
        &.order-count {
          margin-bottom: 2px;
        }
        &.subtotal-price {
          margin-bottom: 2px;
        }

        &.discount-price {
          margin-bottom: 10px;
        }

        // &:not(:last-child) {
        //   margin-bottom: 4px;
        // }

        span {
          display: inline-block;
          text-align: left;
        }
      }

      .skill-total {
        height: 30px;
        color: #999;
        margin-bottom: 14px;
        // font-weight: 500;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
      }
    }
  }

  .skill-refund {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    color: #999;
    font-size: 26px;
    font-weight: 500;
    height: 66px;
    padding-right: 30px;

    .highlight {
      color: #ff891e;
    }
  }
  .operation-container {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .operation-btn {
    width: 92px;
    height: 37px;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    margin: 3px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 37px;
    text-align: center;
    color: #666666;
    cursor: pointer;
  }
  .red-button {
    @include button-yellow;
  }
}
</style>
